import {
  blue,
  cyan,
  geekblue,
  gold,
  green,
  lime,
  magenta,
  orange,
  purple,
  red,
  yellow,
} from '@ant-design/colors';
import { theme, type ThemeConfig } from 'antd';

// ─── Color tokens ────────────────────────────────────────────────────────────

export const COLOR = {
  primary: blue.primary!,
  success: green.primary!,
  warning: yellow.primary!,
  error: red.primary!,
  info: blue.primary!,

  // Semantic/icon colours
  link: blue[5]!,
  locationPin: blue[4]!,

  // Surface
  borderDefault: geekblue[1]!,
  backgroundSubtle: geekblue[1]!,
  emailCanvas: '#ffffff',

  // Re-export full palettes for advanced usage
  blue,
  green,
  red,
  orange,
  yellow,
  purple,
  gold,
  lime,
  geekblue,
  magenta,
  cyan,
} as const;

// ─── Spacing scale ───────────────────────────────────────────────────────────

export const SPACING = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

// ─── Font size scale ─────────────────────────────────────────────────────────

export const FONT_SIZE = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18,
  xxl: 32,
} as const;

export const BORDER_RADIUS = 6;

/**
 * Button size convention:
 *  - size="large"  — primary submit / main CTA buttons (standalone forms)
 *  - size="small"  — inline actions inside table rows
 *  - (default)     — secondary actions in detail/panel views (middle)
 */

// ─── Ant Design ConfigProvider theme ─────────────────────────────────────────

const sharedTokens: ThemeConfig['token'] = {
  colorPrimary: COLOR.primary,
  colorSuccess: COLOR.success,
  colorWarning: COLOR.warning,
  colorError: COLOR.error,
  colorInfo: COLOR.info,
  borderRadius: BORDER_RADIUS,
};

export const themeConfig: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: sharedTokens,
};

export const darkThemeConfig: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...sharedTokens,
    colorBgBase: '#141414',
  },
};
